import React, { useState } from 'react';
import { useLanguage } from '../../Contexts/LanguageContext';

import { Icon } from '../../Elements/Icon';

import constants from '../../constants';
import strings from '../../strings';

const LanguageMenu = ({}) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const { language, setLanguage, setIsInternalChange } = useLanguage();

    return (
        <div className="c-language-menu">
            <button 
                className="c-language-menu__button" 
                onClick={() => setMenuOpen(!menuOpen)} 
                aria-label={strings.LANG_MENU_ARIA_LABEL[language]} 
                aria-expanded={menuOpen}
            >
                <Icon name="globe" withInlineStyle={false} additionalClasses="c-language-menu__button__icon-globe" />
                <Icon name="chevron-down" withInlineStyle={false} additionalClasses="c-language-menu__button__icon-arrow-down" />
            </button>
            <ul className="c-language-menu__items" aria-hidden={!menuOpen}>
                <li className="c-language-menu__item">
                    <button 
                        className="c-language-menu__link" 
                        onClick={() => { 
                            setLanguage(constants.LANGUAGE.SWEDISH); 
                            setIsInternalChange(true);
                            setMenuOpen(false); 
                        }}>
                            Svenska
                    </button>
                </li>
                <li className="c-language-menu__item">
                    <button 
                        className="c-language-menu__link" 
                        onClick={() => { 
                            setLanguage(constants.LANGUAGE.ENGLISH); 
                            setIsInternalChange(true);
                            setMenuOpen(false); 
                        }}>
                            English
                    </button>
                </li>
            </ul>
        </div>
    );
}

export default LanguageMenu;